import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import {
  animateToScreen as animateToScreenAction,
  animateToScreenAndBeep as animateToScreenAndBeepAction,
} from '../../redux/ui/actions';
import TextColumnContent from '../../molecules/TextColumnContent';
import BackButtonContainer from '../../molecules/BackButtonContainer';
import Button from '../../components/Button';
import ButtonContainer from '../../components/ButtonContainer';
import UpperContainer from '../../components/UpperContainer';
import CollapsibleContainer from '../../components/CollapsibleContainer';
import Description from '../../components/Description';
import { H3, Text } from '../../components/Typography';

class SeasonalTicketRegionTexts extends PureComponent {
  // eslint-disable-next-line
  state = { showCardButtonDisabled: false };

  goToConfirmationScreen = () => {
    this.setState({ showCardButtonDisabled: true }, () => {
      this.props.animateToScreenAndBeep('SeasonalTicketConfirmation');
    });
  };

  render() {
    const { showCardButtonDisabled } = this.state;
    const { animateToScreen, t } = this.props;
    return (
      <>
        <BackButtonContainer
          home={t('Generic.breadcrumbHome')}
          homeLink={t('Generic.breadcrumbHomeLink')}
          secondaryHome={t('Generic.breadcrumbSecondaryHome')}
          secondaryHomeLink={t('Generic.breadcrumbSecondaryHomeLink')}
          textPrev={t('Flows.home')}
          text={t('Flows.seasonalTicket')}
          onClick={() => animateToScreen('Home')}
        />
        <TextColumnContent paddingTop={-100} hasBackButton>
          <H3>
            <Trans i18nKey="SeasonalTicketRegion.title" />
          </H3>
          <UpperContainer>
            <Description>
              <Text>
                <Trans i18nKey="SeasonalTicketRegion.description" />
              </Text>
            </Description>
            <ButtonContainer>
              <Button
                onClick={this.goToConfirmationScreen}
                text={t('Generic.showCard')}
                disabled={showCardButtonDisabled}
              />
            </ButtonContainer>
          </UpperContainer>
          <CollapsibleContainer>
            <ButtonContainer>
              <Button
                onClick={this.goToConfirmationScreen}
                text={t('Generic.showCard')}
                disabled={showCardButtonDisabled}
              />
            </ButtonContainer>
            <Collapsible
              trigger={t('Generic.additionalInfo')}
              transitionTime={300}
            >
              <Description>
                <Text>
                  <Trans i18nKey="SeasonalTicketRegion.description" />
                </Text>
              </Description>
            </Collapsible>
          </CollapsibleContainer>
        </TextColumnContent>
      </>
    );
  }
}

SeasonalTicketRegionTexts.propTypes = {
  animateToScreen: PropTypes.func.isRequired,
  animateToScreenAndBeep: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
  animateToScreen: (screenName) => dispatch(animateToScreenAction(screenName)),
  animateToScreenAndBeep: (screenName) => dispatch(animateToScreenAndBeepAction(screenName)), // eslint-disable-line
});

// prettier-ignore
export default connect(null, mapDispatchToProps)(SeasonalTicketRegionTexts);
